import VTooltip from 'v-tooltip';

/*
 * override classes to prevent conflict with bootstrap :(
 * learn more: https://github.com/Akryum/v-tooltip#global-options
 */
const defaults = {
  defaultTemplate: '<div class="m-tooltip" role="tooltip"><div class="m-tooltip-arrow"></div><div class="m-tooltip-inner"></div></div>',
  defaultArrowSelector: '.m-tooltip-arrow, .m-tooltip__arrow',
  defaultInnerSelector: '.m-tooltip-inner, .m-tooltip__inner',
  defaultLoadingClass: 'm-tooltip-loading',
  popover: {
    defaultBaseClass: 'm-tooltip popover',
    defaultInnerClass: 'm-tooltip-inner popover-inner',
    defaultArrowClass: 'm-tooltip-arrow popover-arrow'
  }
};

export default function setupTooltip (Vue) {
  Vue.use(VTooltip, defaults);
}
